import { useEffect, useState } from "react";
import DynamicForm from "../../../components/forms/DynamicForm";
import { moduleConfig } from "../../../config";
import { TableConfig } from "../../table/TableConfig";

const RolesWrapper = (props) => {
    const { onSubmit, closeModal, data, ModalTitle, dta, setData, type } = props;
    const [fields, setFields] = useState(moduleConfig.roles.fields);
    const [formData, setFormData] = useState({ ...data });

    useEffect(() => {
        const reqFields = data ? fields : fields.filter((e) => e.showInCreate && e);
        setFields(reqFields);
    }, []);
    return (
        <DynamicForm
            fields={type === "default" ? fields : moduleConfig.roles.Permissions}
            onSubmit={onSubmit}
            closeModal={closeModal}
            ModalTitle={ModalTitle}
            data={data && formData}
            actions={moduleConfig?.roles?.actions}
            dta={dta}
            setData={setData}
            navId={TableConfig.tables[4].items[0].id}
        />
    );
};

export default RolesWrapper;
